export default function NoConnection() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
      <div className="max-w-md space-y-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-(--brand)">
          Offline
        </p>
        <h1 className="text-2xl font-bold text-foreground">
          You’re offline
        </h1>
        <p className="text-sm text-muted-foreground">
          Check your connection and try again. We’ll reconnect automatically
          once you’re back online.
        </p>
      </div>
    </div>
  );
}
